export const orderStatuses = ["awaiting", "cancelled", "scheduled", "suspended"] as const;

export type OrderStatus = typeof orderStatuses[number];
